import DestinationItem from "./DestinationItem";
function SlideDestination() {
  return (
    <div id="slideDestination">
      <div className="container">
        <DestinationItem />
      </div>
    </div>
  );
}
export default SlideDestination;
